module.exports = __webpack_public_path__ + "img/avatar_default.2d875ddd.svg";